
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.tenant_name = document.head.querySelector('meta[name="tenant"]').content;
    window.formulaOrderEnabledTenant = () => {
        let order_tenants = [
            'altius',
            'tbsolution',
            'dobrovita',
            'geodeti',
            'zolnir',
            'pokrijinzasenci',
            'stolfa'
        ];
        return order_tenants.includes(tenant_name);
    };

    window.isPointsCalculationEnabled = () => {
        let order_tenants = [
            'dobrovita',
            'geodeti',
            'zolnir'
        ];
        return order_tenants.includes(tenant_name);
    };

    window.checkDecimalPlaces = (number, maxDecimalPlaces) => {
        // Convert the number to a string
        const numString = number.toString();

        // Check for the decimal point
        const decimalIndex = numString.indexOf('.');

        if (decimalIndex !== -1) {
            // Calculate the number of decimal places
            const decimalPlaces = numString.length - decimalIndex - 1;

            // Compare with the maximum decimal places allowed
            return decimalPlaces > maxDecimalPlaces;
        }

        // If there's no decimal point, return false
        return false;
    }

    window.updateBundleSubTotal = ($section, $row) => {
        let $quantity = $row.find('td[data-field-name="quantity"]'),
            bundle_id = $quantity.attr('data-bundle-id'),
            row_id = $quantity.attr('data-row-id'),
            $row_quantities = $section.find(`td[data-field-name="quantity"][data-bundle-id="${bundle_id}"]`),
            $bundle_row = $section.find(`tr[data-col="${row_id}"]`),
            $sub_total = $bundle_row.find('td[data-field-name="bundle_subtotal"]'),
            sub_total = 0;

        if(!$sub_total.length){
            return;
        }

        $row_quantities.each(function(index, $row_quantity){
            let $tr = $($row_quantity).parents('tr'),
                $sum_incl_disc_excl_vat = $tr.find('td[data-field-name="sum_incl_disc_excl_vat"]'),
                value = $sum_incl_disc_excl_vat.find('span').text().trim();

            if (decimal_separator !== '.') {
                value = value.replace(/\./g, '').replace(',', '.');
            }
            sub_total += parseFloat(value);
        });

        if (checkDecimalPlaces(sub_total, decimal_numbers)) {
            sub_total = sub_total.toFixed(decimal_numbers);
            sub_total = parseFloat(sub_total);
        }
        if (decimal_separator !== '.') {
            sub_total = sub_total.toString().split('.').join(',');
        }

        $sub_total.find('span').text(sub_total);
        $sub_total.addClass('update');
        $sub_total.attr('data-value', sub_total);
    }

    jQuery.expr.filters.offscreen = function(el) {
        var rect = el.getBoundingClientRect();
        return (
            (rect.x + rect.width) < 0
            || (rect.y + rect.height) < 0
            || (rect.x > window.innerWidth || rect.y > window.innerHeight)
        );
    };

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

import toastr from 'toastr';
window.toastr = toastr;

window.toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": true,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "2500",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut",
    "toastClass" : "toastr",
};

window.translation = $("#translations").attr('data-translations') ? JSON.parse($("#translations").attr('data-translations')) : {};
window.tenant = $(`meta[name="tenant"]`).attr('content');
window.is_mobile = parseInt($(`meta[name="is_mobile"]`).attr('content'));
window.decimal_separator = parseInt($(`meta[name="decimal_separator"]`).attr('content'));
window.decimal_numbers = parseInt($(`meta[name="decimal_numbers"]`).attr('content'));
